import { render } from "./SupportMeasures.vue?vue&type=template&id=702a8689"
import script from "./SupportMeasures.vue?vue&type=script&lang=js"
export * from "./SupportMeasures.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__